import { apiClient } from "api/trpc/trpc-client"
import OrgGuardStore from "features/main/main-router/org-guard/OrgGuardStore"
import { ProcessDocDto } from "../app-services/process/models/documents/ProcessDocDto"
import WebSocketProcessChangeEvent from "../websockets/models/WebSocketProcessChangeEvent"
import { ProcessDto } from "../app-services/process/models/ProcessDto"
import { IDBProcessCache } from "./idb/IDBProcessCache"

interface ProcessCacheStoreProps {
   orgGuardStore: OrgGuardStore
}

export default class ProcessCacheStore {
   sp
   private _publishedProcesses: ProcessDto.entity[] = []
   private _publishedProcessDocs: ProcessDocDto[] = []

   constructor(sp: ProcessCacheStoreProps) {
      this.sp = sp
   }

   get hasWorkItemPermission() {
      return this.sp.orgGuardStore.doesUserHaveFeaturePermission({
         featureId: 'work-items'
      })
   }

   /**
    * Retrieves blueprints for a process and doc type
    */
   getDocTypeBlueprints = (processId: string, docTypeId: string): string[] => {
      return this._publishedProcessDocs
         .filter(x => x.processId === processId && x.docTypeId === docTypeId)
         .flatMap(p => [
            ...(p.blueprintId ? [p.blueprintId] : []),
            ...(p.alternateBlueprintIds ?? [])
         ])
   }

   handleProcessChangeEvent = (processChangeEvent: WebSocketProcessChangeEvent) => {
      switch (processChangeEvent.action) {
         case 'change':
            this.fetch()
            break
      }
   }

   fetch = async () => {
      if (this.hasWorkItemPermission && this.sp.orgGuardStore.userOrg.orgType === 'advisor') {
         const { processDocs, publishedProcesses } = await apiClient.processDoc.publishedProcessesAndDocs.query()
         this._publishedProcessDocs = processDocs
         this._publishedProcesses = publishedProcesses
      } else if (this.sp.orgGuardStore.userOrg.orgType === 'gap') {
         await IDBProcessCache.invalidate(['draft', 'published', 'archived'])
         await IDBProcessCache.getByStatus(['draft', 'published', 'archived'])
      }
   }

   getProcess = (keys: ProcessDto.keys) => {
      return this._publishedProcesses.find(x => {
         return x.id === keys.id && x.orgId === keys.orgId
      })
   }
}
